import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';

type EmployeeGrantAccessRequest = {
  accountId: number;
  hiringPermission: string;
  employeesPermission: string;
  newEmail?: string;
};

export const grantEmployeeAccess = (
  employeeId: number,
  orgId: number,
  employeeGrantAccessRequest: EmployeeGrantAccessRequest,
) =>
  createGenericDispatcher<{ user?: User; warningMessage?: string }>({
    name: 'GRANT_EMPLOYEE_ACCESS',
    loadFunction: () =>
      Api.post(`/employee/${employeeId}/grant-access`, {
        body: JSON.stringify(employeeGrantAccessRequest),
      }),
    args: { employeeId, orgId, employeeGrantAccessRequest },
  });
